import { api } from "./api";

export const discountOffersList = async (addUrl = "") => {
    return await api.get(`/discount-offers-list?${addUrl}`);
};

export const discountOffersAdd = async (data) => {
    return await api.post(`/discount-offers-add`, data);
};

export const discountOffersUpdate = async (data) => {
    return await api.post("/discount-offers-update", data);
};

export const discountOffersDelete = async (id) => {
    return await api.post(`/discount-offers-delete`, { id });
};

export const discountOffersStatusUpdate = async (id) => {
    return await api.post(`/discount-offers-status-change`, { id });
};
